export const createHashTag = text => `#${text}`.replace(/\s/g, '\xa0');
